import { z } from 'zod'

import { pricingBreakdownSchema } from './pricing'
import { AttributionType } from '../constants/attribution'
import { SaleCommissionType, SaleStatus } from '../constants/sale'
import { bookingFeeSchema } from './booking'
import { InventoryType } from '../constants/inventory'
import { BookingPaymentType } from '../constants/booking'
import { dbEntitySchema } from './system'

export const salePricingBreakdownSchema = z.object({
  ...pricingBreakdownSchema,
  additionalSpend: z.number().default(0),
  venueFeeTotal: z.number().default(0),
  venueAbsorbedProcessingFeeTotal: z.number().default(0),
  processingFeeTotal: z.number().default(0),
  userPaidProcessingFeeTotal: z.number().default(0),
  tablelistFeeTotal: z.number().default(0),
  venuePayout: z.number().default(0),
  fees: z.array(bookingFeeSchema).optional(),
  processingFees: z.array(bookingFeeSchema).optional(),
})

export const saleSchema = dbEntitySchema.extend({
  booking: z.string(),
  city: z.string().nullish(),
  event: z.string().nullish(),
  affiliate: z.string(),
  tracker: z.string(),
  date: z.date(),
  exportDate: z.date(),
  purchaseDate: z.date(),
  user: z.string().nullish(),
  prospect: z.string().nullish(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  phone: z.string().nullish(),
  email: z.string().nullish(),
  client: z.string().nullish(),
  attributionId: z.string().nullish(),
  attributionType: z.nativeEnum(AttributionType).nullish(),
  base: salePricingBreakdownSchema,
  final: salePricingBreakdownSchema,
  currencyCode: z.string().nullish(),
  status: z.nativeEnum(SaleStatus).nullish(),
  commission: z
    .object({
      type: z.nativeEnum(SaleCommissionType),
      amount: z.number().min(0).default(0),
      value: z.number().min(0).default(0),
    })
    .nullish(),
  accountExecutive: z.string().nullish(),
  inventory: z.string().nullish(),
  inventoryType: z.nativeEnum(InventoryType).nullish(),
  paymentType: z.nativeEnum(BookingPaymentType).nullish(),
  voided: z.boolean().nullish(),
  chargebackStatus: z.string().nullish(),
  paymentProviderAccountId: z.string().nullish(),
  paymentProviderPayoutStatus: z.string().nullish(),
  paymentProviderChargeId: z.string().nullish(),
  paymentProviderSettlementCurrencyCode: z.string().nullish(),
  paymentProviderExchangeRate: z.number().nullish(),
  paymentProviderChargeUsd: z.number().nullish(),
  paymentProviderProcessingFee: z.number().nullish(),
  paymentProviderProcessingFeeUsd: z.number().nullish(),
  paymentProviderApplicationFee: z.number().nullish(),
  paymentProviderApplicationFeeUsd: z.number().nullish(),
})
